import React, { useState, useEffect } from "react";
import "./SocialCanvassing.css";
import "bootstrap/dist/css/bootstrap.min.css";
import OptionsCards from "../../components/OptionsCards/OptionsCards";
import PromoBanner from "../../components/PromoBanner/PromoBanner";
import { use } from "react";

export default function SocialCanvassing({
  selectedSocialCanvassOptions,
  exportDetailsVal,
  onSocialCanvassChange,
  onExportDetailsChange
}) {
  const options = [
    {
      id: 5,
      title: "Deep Report",
      name: "deepReport",
      description:
        "",
      features: [
        { title: "Confirmed results verified with at least three instances of personal identifiers including subjects' public records, social media, and web results.", isDisabled: false },
        { title: "Each result includes source code and metadata, and can be used as evidence and brought into your e-discovery database.", isDisabled: false },
      ],
      header: "",
      locations: [],
    },
    {
      id: 6,
      title: "Exports",
      name: "exports",
      description:
        "",
      features: [
        { title: "Visual Capture of content from a single social media profile or URL.", isDisabled: false },
        { title: "Preserves digital chain of custody using source code and metadata with timestamps in HTML format for the entire profile of URL.", isDisabled: false },
      ],
      header: "",
      locations: [],
      showExportText: true,
    },
    {
      id: 7,
      title: "Research Bundle",
      name: "researchBundle",
      description:
        "",
      features: [
        { title: "Combines the Deep Report and three Exports. The top three social media platform results will be automatically exported.", isDisabled: false },
      ],
      header: "",
      locations: [],
      showExportText: true,
    },
    {
      id: 8,
      title: "I Do NOT Want a Social Canvass Completed",
      name: "noSocialCanvass",
      description: "",
      features: [],
      header: "",
      locations: [],
    },
  ];

  const [exportDetailsValue, setExportDetailsValue] = useState("");
  const [exportURLsError, setExportURLsError] = useState("")

  const [selectedOptions, setSelectedOptions] = useState({
    deepReport: false,
    exports: false,
    researchBundle: false,
    noSocialCanvass: false
  });

  const handleOptionChange = (option) => {
    setSelectedOptions(prev => {
      if (option.id === 7) { //researchBundle
        return {
          ...prev,
          deepReport: false,
          exports: false,
          noSocialCanvass: false,
          researchBundle: !prev.researchBundle
        };
      } else if (option.id === 8) { //noSocialCanvass
        return {
          ...prev,
          deepReport: false,
          exports: false,
          researchBundle: false,
          noSocialCanvass: !prev.noSocialCanvass
        };
      }

      // If other options are selected when Research Bundle is active
      if (prev.researchBundle && option.id !== 8) {
        return prev;
      }

      // Normal option selection
      return {
        ...prev,
        [option.name]: !prev[option.name],
        noSocialCanvass: false
      };
    });
  };

  const isValidUrl = urlString => {
    var urlPattern = new RegExp('^(https?:\\/\\/)' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
    return !!urlPattern.test(urlString);
  }

  useEffect(() => {
    const _selectedOptions = options.filter(option => selectedOptions[option.name]);
    onSocialCanvassChange(_selectedOptions);
  }, [selectedOptions]);

  useEffect(() => {
    const trimmed = exportDetailsValue?.trim() ?? "";
    const tokens = trimmed ? trimmed.split(/\s+/).map(token => token.trim()) : [];

    if (selectedOptions.exports && tokens.length === 0) {
      setExportURLsError("You must enter one URL");
      onExportDetailsChange(exportDetailsValue, false);
      return;
    }

    if (tokens.length > 1 && selectedOptions.exports) {
      setExportURLsError("You can only enter one URL");
      onExportDetailsChange(exportDetailsValue, false);
      return;
    }

    if (tokens.length > 3 && selectedOptions.researchBundle) {
      setExportURLsError("You can only enter 3 URLs maximum.");
      onExportDetailsChange(exportDetailsValue, false);
      return;
    }

    const invalidUrls = tokens?.filter(token => !isValidUrl(token));
    if (invalidUrls?.length > 0) {
      setExportURLsError("All data entered must be a valid URL")
      onExportDetailsChange(exportDetailsValue, false);
    } else {
      setExportURLsError("")
      onExportDetailsChange(exportDetailsValue, true);
    }
  }, [exportDetailsValue, selectedOptions]);

  useEffect(() => {
    const _selectedOptions = selectedSocialCanvassOptions.reduce((acc, option) => {
      return {
        ...acc,
        [option.name]: true
      };
    }, {});
    setSelectedOptions(_selectedOptions);
    setExportDetailsValue(exportDetailsVal);
  }, [])

  return (
    <div>
      <h1 className="txt-orange" id="SocialCanvassing">Social Canvassing</h1>
      <div className="container">
        <PromoBanner />
        <OptionsCards
          options={options}
          selectedOptions={selectedSocialCanvassOptions}
          onCheckboxChange={(option) => handleOptionChange(option)}
          onExportChange={(value) => setExportDetailsValue(value)}
          disabledOptions={selectedOptions.researchBundle ? options.filter(o => [5, 6].includes(o.id)) : []}
          exportDetailsValue={exportDetailsValue}
          exportURLsError={exportURLsError}
        />
      </div>
    </div>
  );
}
